import { useTranslation } from 'react-i18next'
import { connectSortBy } from 'react-instantsearch-dom'

import icons from '../../assets/BuildIcons/Icons'
import TickMark from '../../assets/TickMark.svg'
import './Sort.scss'

let label: any
const OptionValue = (props: any) => {
  if (label === undefined) {
    label = props.initialVal
  }
  return <span>{label}</span>
}

const SortBy = ({
  items,
  refine,
  createURL,
}: {
  items: any
  refine: any
  createURL: any
}) => {
  const { t } = useTranslation()
  const win = window
  const localhost = win.location.hostname === 'localhost'

  return (
    <>
      <div className="desktopSort">
        <ul className="list">
          {items.map((item: any) => (
            <li
              key={item.value}
              className="sortOption"
              style={{ background: item.isRefined ? '#E6F4FF' : '#FFFFFF' }}
            >
              <a
                className="options"
                href={createURL(item.value)}
                style={{ color: item.isRefined ? '#008CFF' : '#51565B' }}
                onClick={event => {
                  event.preventDefault()
                  refine(item.value)
                  label = item.label
                }}
              >
                <div className="optionData">
                  <div>
                    {item.isRefined ? (
                      <div className="selected">{t('currently_selected')}</div>
                    ) : (
                      <></>
                    )}
                    <div className="optionLabel">{item.label}</div>
                  </div>
                  <div>
                    {item.isRefined ? (
                      <img
                        className="tickMark"
                        src={localhost ? TickMark : icons.tickMark}
                        alt="tickMark"
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

const Sort = connectSortBy(SortBy)

export { Sort, OptionValue }
